import multiagent from "./multiagent";
import login from "./login";
import service from "./service"; //服务中心
import tradeinfo from "./tradeinfo"; //交易信息
import accountinfo from "./accountinfo"; //账户资料
import funds from "./funds"; //账户资料
import bindAccount from "./bindAccount";
import home from "./home"; //首页
import upgrade from "./upgrade";
import activity from "./activity";
import Invitefriends from "./Invitefriends";
import dollarGift from "./dollarGift";
import integration from "./integration";
import digital from "./digital";

export {
  multiagent,
  login,
  service, //服务中心
  tradeinfo, //交易信息
  accountinfo, //账户资料
  funds, //资金管理
  bindAccount,
  home,
  upgrade,
  activity,
  Invitefriends,
  dollarGift,
  integration,
  digital
};



// WEBPACK FOOTER //
// ./src/api/index.js